"use strict";

import PageCommon from "./PageCommon.js";
import Profile from "./Profiles/Profile.js";
import ArtistProfile from "./Profiles/ArtistProfile.js";

import Globals from "../Globals.js";

export default class UserManager extends PageCommon {
    constructor() {
        super();
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("UserManager - constructor");
        this.userLogged = null;
        this.userPlaylists = [];
        this.dataManager = null;

        Globals.userManager = this;

        this.profiles = {
            profile: new Profile(),
            artistProfile: new ArtistProfile(),
        };
    }

    setDataManager(dataManager) {
        this.dataManager = dataManager;
    }

    setCurrentUser({ loadDataManager }) {
        const token = this.getCookie("user_token");
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cUserdata - Set Current user", "color: orange");
        if (token) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cUserdata - Token present, making call", "color: orange");
            fetch(`${Globals.WS_URL}?mode=USERDATA&token=${token}&rand=${Date.now()}`)
                //  fetch(`/apisounzone/getUserData/?token=${token}`)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cUserdata - User Data Result", "color: orange");
                    // if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                    if (result.user && result.user.ID !== 0) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cUserdata - OK", "color: orange");
                        this.userLogged = result.user;
                        this.setMyplaylists({ loadDataManager });
                    } else {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cUserdata - No User Data", "color: orange");
                        this.deleteCookie("user_token");
                        this.emitEvent("user_ready", { detail: { loadDataManager: loadDataManager } });
                    }
                })
                .catch((error) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cUserdata - ERROR USER REQUEST", "color: orange", { message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%Userdata - Token NOT present", "color: orange");
            this.emitEvent("user_ready", { detail: { loadDataManager: loadDataManager } });
        }
    }

    setMyplaylists({ loadDataManager }) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Playlists - getMyplaylists");
        const token = this.getCookie("user_token");
        if (token) {
            fetch(`${Globals.WS_URL}?mode=PLAYLIST.LIST&token=${token}`)
                //   fetch(`/apisounzone/getmyplaylist/?token=` + token)
                .then(this.handleResponse)
                .then((result) => {
                    if (result.error) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Playlists - getMyplaylists ERROR: " + result.error);
                        return;
                    }
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Playlists - getMyplaylists OK");
                    this.userPlaylists = result.data.playlists;
                    this.emitEvent("user_ready", { detail: { loadDataManager: loadDataManager } });
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Playlists - getMyplaylists NO TOKEN");
        }
    }

    setUserEvents() {
        if (window.localStorage.getItem("licenses_tracks") && window.localStorage.getItem("licenses_tracks") !== "") {
            let licenses_tracks = window.localStorage.getItem("licenses_tracks").split(",");
            document.querySelector("#mainMenu .licenses .nav-link .badge").textContent = licenses_tracks.length === 0 ? "" : licenses_tracks.length;
        }

        if (this.userLogged) {

            // 220403
            let ftnum = document.querySelectorAll(".ftNoUserMode");
            for (let i = 0; i < ftnum.length; i++) ftnum[i].style.display = "none";

            document.querySelector("nav .nav-item.login").style.display = "none";
            document.querySelector("nav .user-controls .logout").style.display = "";
            if (!this.userLogged.is_artist && document.querySelector("nav .user-controls .artist-profile")) {
                document.querySelector("nav .user-controls .artist-profile").remove();
            }
            this.checkSubscriptionsValidity();

            // 220405
            if (!this.isActiveSubscription()) {
                let ftum = document.querySelectorAll(".ftUserMode");
                for (let i = 0; i < ftum.length; i++) ftum[i].style.display = "block";
            } else {
                let fts = document.querySelectorAll(".ftSub");
                for (let i = 0; i < fts.length; i++) fts[i].style.display = "block";
            }

        } else {
            if (document.querySelector("nav .user-controls")) {
                document.querySelector("nav .user-controls").remove();
            }
            if (document.querySelector("#playlistsMenu")) {
                document.querySelector("#playlistsMenu li a").href = "#notLoggedModal";
            }
        }
        this.registrationEvent();
        this.loginEvent();
        this.logoutEvent();
    }

    isActiveSubscription() {
        let valid = false;
        if (this.userLogged.subscriptions.length > 0) {
            this.userLogged.subscriptions.map((subscription) => {
                const dt1 = this.extractDate(subscription.dt1);
                const dt2 = this.extractDate(subscription.dt2);
                if (dt2 > new Date() && subscription.type!="0") {
                    valid = true;
                }
            });
        }
        return valid;
    }

    checkSubscriptionsValidity() {
        if (document.querySelector("nav .subscribe-controls .register")) {
            document.querySelector("nav .subscribe-controls .register").remove();
        }
        const valid = this.isActiveSubscription();
        if (valid) {
            if (document.querySelector("nav .subscribe-controls .mysubscriptions")) {
                document.querySelector("nav .subscribe-controls .mysubscriptions").style.display = "";
            }
            return;
        }
        if (document.querySelector("nav .subscribe-controls .subscribe")) {
            document.querySelector("nav .subscribe-controls .subscribe").style.display = "";
        }
    }

    registrationEvent() {
        const _this = this;
        const registerModal = document.querySelector("#registerModal");
        const form = registerModal.querySelector(".form-container form");

        this.dataManager.dataStructure.countries.map((country) => {
            const option = document.createElement("option");
            option.value = country.ID;
            option.textContent = country.Name;
            form.querySelector("select#s-country").appendChild(option);
        });

        form.addEventListener("submit", (event) => {
            event.preventDefault();

            const data = new FormData(event.target);
            const email = data.get("s-email");
            const password = data.get("s-pwd");
            const fullname = data.get("s-name");
            const privacy = form.querySelector("input#s-privacy");
            const is_company = form.querySelector("select#s-is_company").value === "company" ? 1 : 0;
            const country = form.querySelector("select#s-country").value;

            if (email === "") {
                return this.errorManager(form, "Registration - Error email field empty");
            }
            if (password === "") {
                return this.errorManager(form, "Registration - Error password field empty");
            }
            if (fullname === "") {
                return this.errorManager(form, "Registration - Error name field empty");
            }
            if (!privacy || privacy.checked === false) {
                return this.errorManager(form, "Registration - Error privacy field not checked");
            }
            if (country === "") {
                return this.errorManager(form, "Registration - Error country field empty");
            }

            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Registration - Start");

            fetch(
                `${Globals.WS_URL}?mode=REGISTER&user_email=${email}&user_password=${password}&user_fullname=${fullname}&user_is_company=${is_company}&user_country=${country}`
            )
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                    if (result.error) {
                        return this.errorManager(form, `Registration - ERROR: ${result.error}`);
                    }
                    if (result.user) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Registration - OK");
                        this.userLogged = result.user;
                        if (this.userLogged.token !== "" && this.userLogged.token !== false) {
                            gtag("event", "conversion", { "send_to": "AW-658118760/hm1pCMPH89oCEOiw6LkC", 'transaction_id': "" });
                            /*
                            this.showSubscriptionModal();
                            this.dataManager.renderSubscriptionData();
                            return this.setCookie("user_token", this.userLogged.token);
                            //*/
                            this.setCookie("user_token", this.userLogged.token);
                            // ---
                            setTimeout(() => {
                                window.location.href = "/free-trial";
                            }, 1000);
                        } else {
                            return this.errorManager(form, "Registration - Error NO token in response");
                        }
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        });

        registerModal.querySelector(".social-login-container button.facebook").addEventListener("click", () => {
            _this.socialLogin("facebook");
        });
        registerModal.querySelector(".social-login-container button.google").addEventListener("click", () => {
            _this.socialLogin("google");
        });
    }

    showSubscriptionModal() {
        const showSubscriptionRegisterModal = document.querySelector("#showSubscriptionRegisterModal");
        jQuery("#showSubscriptionRegisterModal").modal("show");
        Array.from(showSubscriptionRegisterModal.querySelectorAll(".finish-register")).map((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                window.location.reload();
            });
        });
        this.profiles.profile.buySubscription(this.userLogged.token);
    }

    loginEvent() {
        const _this = this;
        const loginModal = document.querySelector("#loginModal");
        const form = loginModal.querySelector(".form-container form");
        form.addEventListener("submit", (event) => {
            event.preventDefault();

            const data = new FormData(event.target);
            const email = data.get("s-email");
            const password = data.get("s-pwd");

            if (email === "") {
                return this.errorManager(form, "Login - Error email field empty");
            }
            if (password === "") {
                return this.errorManager(form, "Login - Error password field empty");
            }

            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Login - Start");

            const dafUrl = Globals.WS_URL +"?mode=LOGIN&user_email=" + email +"&user_password=" + escape(password);

            fetch(dafUrl)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Login - Response");
                    if (result.error) {
                        return this.errorManager(form, `Login - ERROR: ${result.error}`);
                    }
                    if (result.user) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Login - OK");
                        this.userLogged = result.user;
                        if (this.userLogged.token !== "" && this.userLogged.token !== false) {
                            window.location.reload();
                            return this.setCookie("user_token", this.userLogged.token);
                        } else {
                            return this.errorManager(form, "Login - Error NO token in response");
                        }
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        });

        loginModal.querySelector(".social-login-container button.facebook").addEventListener("click", () => {
            _this.socialLogin("facebook");
        });
        loginModal.querySelector(".social-login-container button.google").addEventListener("click", () => {
            _this.socialLogin("google");
        });
    }

    logoutEvent() {
        const logoutButton = document.querySelector("nav .user-controls .logout");
        if (logoutButton) {
            logoutButton.addEventListener("click", (event) => {
                event.preventDefault();

                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Logout - Start");

                const token = this.getCookie("user_token");
                this.deleteCookie("user_token");

                // window.localStorage.removeItem("licenses_tracks");

                fetch(`${Globals.WS_URL}?mode=LOGOUT&token=${token}`)
                    .then(this.handleResponse)
                    .then((result) => {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Logout - OK");
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                        window.location.reload();
                    })
                    .catch((error) => {
                        Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                        jQuery(".js-critical-error").show();
                    });
            });
        }
    }

    errorManager(form, error) {
        form.querySelector(".error-wrapper").textContent = error;
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(error);
    }
}
